import React, { useState } from 'react'
import SectionHeading from './SectionHeading'
import { ContentSection, ImageType } from '../../types/types'
import { API } from '../../data/constants'
import PopupLeitbild from './PopupLeitbild'
import { useOnScreen } from '../common/smoothInEffektHook'
import { motion } from 'framer-motion'

type leitbildData = {
    content?: {
        heading: string
        subheading: string
        kopfbildung: {
            bild: {
                data: ImageType
            }
            heading: string
            text: string
        }
        herzbildung: {
            bild: {
                data: ImageType
            }
            heading: string
            text: string
        }
    }
}

type ContentKeys =
    | 'kopfbildung'
    | 'herzbildung'

function SectionLeitbild({ content }: leitbildData) {
    const [popupOpen, setPopupOpen] = useState(false)
    const [popupContent, setPopupContent] = useState<ContentSection>()
    const closePopup = () => setPopupOpen(false)

    const openPopupWithSection = (sectionKey: ContentKeys) => {
        if (content) {
            const sectionContent = content[sectionKey] as ContentSection
            if (sectionContent) {
                setPopupContent(sectionContent) // Assuming you store this in state
                setPopupOpen(true)
            }
        }
    }

    const [ref1, isVisible1] = useOnScreen({ threshold: 0.8 })
    const [ref2, isVisible2] = useOnScreen({ threshold: 0.5 })

    return (
        <div id="leitbild">
            <SectionHeading heading={content?.heading} subheading={content?.subheading} />
            <div className="grid grid-cols-1 sm:grid-cols-2  mx-auto gap-4 max-w-page px-4 xl:px-0 ">
                <motion.div
                    ref={ref1}
                    initial={{ opacity: 0, y: -100 }}
                    animate={isVisible1 && { opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                    onClick={() => openPopupWithSection('kopfbildung')}
                    className="hover:cursor-pointer relative flex justify-center items-center p-16 sm:p-32 border-8 border-orange_dark rounded-2xl">
                    <img
                        className="w-full h-full absolute top-0 left-0 object-cover brightness-75 rounded"
                        src={
                            API.img +
                            content?.kopfbildung?.bild?.data?.attributes?.url
                        }
                        alt=""
                    />
                    <div className="font-permanentMarker text-2xl sm:text-3xl md:text-4xl z-10 text-primary text-center">
                        {content?.kopfbildung?.heading}
                    </div>
                </motion.div>
                <motion.div
                    ref={ref2}
                    initial={{ opacity: 0, x: 100, y: -50 }}
                    animate={isVisible2 && { opacity: 1, x: 0, y: 0 }}
                    transition={{ duration: 1 }}
                    onClick={() => openPopupWithSection('herzbildung')}
                    className="hover:cursor-pointer p-16 sm:p-32 relative flex justify-center items-center  border-8 border-blue_dark rounded-2xl">
                    <img
                        className="w-full h-full absolute top-0 left-0 object-cover brightness-75 rounded"
                        src={
                            API.img +
                            content?.herzbildung?.bild?.data
                                ?.attributes?.url
                        }
                        alt=""
                    />
                    <div className="font-permanentMarker text-2xl sm:text-3xl md:text-4xl z-10 text-primary text-center">
                        {content?.herzbildung?.heading}
                    </div>
                </motion.div>

            </div>
            {popupOpen && popupContent && (
                <PopupLeitbild
                    onClose={closePopup}
                    contentSection={popupContent}
                />
            )}
        </div>
    )
}

export default SectionLeitbild
